export default {
  uploading: 'Uploading',
  cancel: 'Cancel',
  modelTrainingProgress: 'Model Training Progress',
  stage: 'Stage',
  deliverables: 'Deliverables',
  status: 'Status',
  actions: 'Actions',
  completed: 'Completed',
  pending: 'Pending',
  approveStage: 'Approve Stage',
  undoApproval: 'Undo approval',
  upload: 'Upload',
  deleteFileConfirm: 'Are you sure you want to delete the file?',
  unsupportedFiles: 'These files were skipped because only HTML reports and Excel spreadsheets (.xlsx, .xls) can be uploaded: {files}',
  errorUploadingFile: 'Error uploading file.',
  viewReport: 'View report',
  downloadDeliverable: 'Download {name}',
  deliverableKinds: {
    report: 'Report',
    modelReport: 'Excel Model Report',
    inputsReport: 'Inputs Report'
  },
  assignTitle: 'Upload to {stage}',
  assignHint: 'Assign each spreadsheet to its kind before uploading. A single spreadsheet, or a pair where only one has "input" in its name, comes pre-assigned.',
  assignPlaceholder: 'Choose a kind',
  tooManySpreadsheets: 'Up to {max} spreadsheets can be uploaded at once (one Excel Model Report and one Inputs Report). Nothing was uploaded.',
  assignRepeated: 'More than one file is set as {kinds}: they will be uploaded as consecutive versions.',
  uploadingCount: '({current} of {total})',
  sendFeedback: 'Send Feedback',
  feedbackUnavailable: 'Available once {stage} has a report or spreadsheet',
  feedbackStaff: 'NG team',
  feedbackFirst: 'First feedback: {date}',
  feedbackLast: 'Latest: {date}'
}
